import type { CustomAttributes } from "app/services/track/track";
import { allTrackers } from "app/services/track/track";

import type { TrackingServiceDeps } from "./types";

function createFeatureUpgradeTrackingService({ track }: TrackingServiceDeps) {
    function trackWithTableCategory(action: string, event: string, customAttributes?: CustomAttributes) {
        track("upgrade_banner", action, event, customAttributes);
    }

    return {
        /** `customAttributes` carries whatever dimensions the surface already has to hand. */
        trackFeatureAccessRequested(feature = "", customAttributes?: CustomAttributes) {
            trackWithTableCategory("click", `request access/${feature}`, customAttributes);
        },
    };
}

export default createFeatureUpgradeTrackingService({
    track: allTrackers.dispatchTrackEvent.bind(allTrackers),
});
